import React from "react";

export default function Footer() {
    return (
        <div className='footer'>
            <div className='inner'>
                <div>
                    <div className='sub'>BERGISCH.METALL KOMPETENZVERBUND</div>
                    <div className='head'>UNTERNEHMENSPROFIL ERSTELLEN </div>
                    <div className='sub-2'>
                        Melden Sie sich bei bergisch.metall an und werden sie
                        Teil des Netzwerks!
                    </div>
                </div>
                <div>
                    <a className='register' href='/portal'>
                        Jetzt Anmelden
                    </a>
                </div>
            </div>
        </div>
    );
}
